import createWebStorage from "redux-persist/lib/storage/createWebStorage";

// Create a storage object that doesn't throw errors when localStorage is not available
const createNoopStorage = () => {
  return {
    getItem() {
      return Promise.resolve(null);
    },
    setItem(_key: string, value: any) {
      return Promise.resolve(value);
    },
    removeItem() {
      return Promise.resolve();
    },
  };
};

// Check if window is defined (running on client)
const storage =
  typeof window !== "undefined"
    ? createWebStorage("local") // Use localStorage if on client
    : createNoopStorage(); // Use dummy storage if on server

export default storage;
